import { useAuth } from '../../hooks/useAuth'

function AdminAccounting() {
  const { userData } = useAuth()

  return (
    <div className="bg-white dark:bg-slate-800 rounded-2xl border border-slate-200 dark:border-slate-700 p-8">
      <h3 className="text-xl font-semibold text-slate-900 dark:text-white">Contabilidad</h3>
      <p className="text-slate-500 dark:text-slate-300 mt-2">
        Módulo en desarrollo para {userData?.displayName || 'Administrador'}.
      </p>
      <div className="mt-6 flex items-center gap-3 text-slate-500 dark:text-slate-300">
        <span className="material-icons-round text-emerald-600">info</span>
        <span className="text-sm">Aquí se incorporarán reportes, balances y herramientas contables.</span>
      </div>
    </div>
  )
}

export default AdminAccounting
